"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetClient = void 0;
const client_1 = require("@leid/client");
class AssetClient extends client_1.ClientBase {
    async getSuppliers(filter) {
        try {
            const response = await this.httpClient.get('/suppliers', {
                params: filter,
            });
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getSuppliers error on a call', filter);
        }
    }
    async getSupplier(id) {
        try {
            const response = await this.httpClient.get(`/suppliers/${id}`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getSupplier error on a call', id);
        }
    }
    async createSupplier(supplier) {
        try {
            const response = await this.httpClient.post('/suppliers', supplier);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'createSupplier error on a call', supplier);
        }
    }
    async updateSupplier(id, supplier) {
        try {
            const response = await this.httpClient.put(`/suppliers/${id}`, supplier);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'updateSupplier error on a call', id, supplier);
        }
    }
    async getManufacturers(filter) {
        try {
            const response = await this.httpClient.get('/manufacturers', {
                params: filter,
            });
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getManufacturers error on a call', filter);
        }
    }
    async getManufacturer(id) {
        try {
            const response = await this.httpClient.get(`/manufacturers/${id}`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getManufacturer error on a call', id);
        }
    }
    async createManufacturer(manufacturer) {
        try {
            const response = await this.httpClient.post('/manufacturers', manufacturer);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'createManufacturer error on a call', manufacturer);
        }
    }
    async updateManufacturer(id, manufacturer) {
        try {
            const response = await this.httpClient.put(`/manufacturers/${id}`, manufacturer);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'updateManufacturer error on a call', id, manufacturer);
        }
    }
    async getAssetModels(filter) {
        try {
            const response = await this.httpClient.get('/assetModels', {
                params: filter,
            });
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getAssetModels error on a call', filter);
        }
    }
    async getAssetModel(id) {
        try {
            const response = await this.httpClient.get(`/assetModels/${id}`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getAssetModel error on a call', id);
        }
    }
    async createAssetModel(assetModel) {
        try {
            const response = await this.httpClient.post('/assetModels', assetModel);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'createAssetModel error on a call', assetModel);
        }
    }
    async updateAssetModel(id, assetModel) {
        try {
            const response = await this.httpClient.put(`/AssetModels/${id}`, assetModel);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'updateAssetModel error on a call', id, assetModel);
        }
    }
    // ====== Asset Devices ======
    async getDevices(filter) {
        try {
            const response = await this.httpClient.get('/devices', {
                params: filter,
            });
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getDevices error on a call', filter);
        }
    }
    async getDevice(id) {
        try {
            const response = await this.httpClient.get(`/devices/${id}`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getDevice error on a call', id);
        }
    }
    async createDevice(device) {
        try {
            const response = await this.httpClient.post('/devices', device);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'createDevice error on a call', device);
        }
    }
    async updateDevice(id, device) {
        try {
            const response = await this.httpClient.put(`/devices/${id}`, device);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'updateDevice error on a call', id, device);
        }
    }
    async increaseDeviceFinancePeriodPaidAmount(id) {
        try {
            const response = await this.httpClient.put(`/devices/${id}/increase-finance-periods-paid`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'increaseDeviceFinancePeriodPaidAmount error on a call', id);
        }
    }
    // assetInspection
    async getAssetInspections(filter) {
        try {
            const response = await this.httpClient.get('/asset-inspections', {
                params: filter,
            });
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getAssetInspections error on a call', filter);
        }
    }
    async getAssetInspection(id) {
        try {
            const response = await this.httpClient.get(`/asset-inspections/${id}`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getAssetInspection error on call', id);
        }
    }
    async createAssetInspection(assetInspection) {
        try {
            const response = await this.httpClient.post('/asset-inspections', assetInspection);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'createAssetInspection error on call', assetInspection);
        }
    }
    async deleteAssetInspection(id) {
        try {
            const response = await this.httpClient.delete(`/asset-inspections/${id}`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'deleteAssetInspection error on call', id);
        }
    }
    // rule
    async getRules(filter) {
        try {
            const response = await this.httpClient.get('/rules', {
                params: filter,
            });
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getRules error on a call', filter);
        }
    }
    async getRule(id) {
        try {
            const response = await this.httpClient.get(`/rules/${id}`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getRule error on call', id);
        }
    }
    async createRule(rule) {
        try {
            const response = await this.httpClient.post('/rules', rule);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'createRule error on call', rule);
        }
    }
    async deleteRule(id) {
        try {
            const response = await this.httpClient.delete(`/rules/${id}`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'deleteRule error on call', id);
        }
    }
    async updateRule(id, rule) {
        try {
            const response = await this.httpClient.put(`/rules/${id}`, rule);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'updateRule error on a call', id, rule);
        }
    }
    // assetLifecycle
    async getAssetLifecycles(filter) {
        try {
            const response = await this.httpClient.get('/asset-lifecycles', {
                params: filter,
            });
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getAssetLifecycles error on a call', filter);
        }
    }
    async getAssetLifecycle(id) {
        try {
            const response = await this.httpClient.get(`/asset-lifecycles/${id}`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getAssetLifecycle error on call', id);
        }
    }
    async createAssetLifecycle(assetLifecycle) {
        try {
            const response = await this.httpClient.post('/asset-lifecycles', assetLifecycle);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'createAssetLifecycle error on call', assetLifecycle);
        }
    }
    async deleteAssetLifecycle(id) {
        try {
            const response = await this.httpClient.delete(`/asset-lifecycles/${id}`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'deleteAssetLifecycle error on call', id);
        }
    }
    async updateAssetLifecycle(id, assetLifecycle) {
        try {
            const response = await this.httpClient.put(`/asset-lifecycles/${id}`, assetLifecycle);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'updateAssetLifecycle error on a call', id, assetLifecycle);
        }
    }
    // assetEvent
    async getAssetEvents(filter) {
        try {
            const response = await this.httpClient.get('/asset-events', {
                params: filter,
            });
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getAssetEvents error on a call', filter);
        }
    }
    async getAssetEvent(id) {
        try {
            const response = await this.httpClient.get(`/asset-events/${id}`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getAssetEvent error on call', id);
        }
    }
    async createAssetEvent(assetEvent) {
        try {
            const response = await this.httpClient.post('/asset-events', assetEvent);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'createAssetEvent error on call', assetEvent);
        }
    }
    async deleteAssetEvent(id) {
        try {
            const response = await this.httpClient.delete(`/asset-events/${id}`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'deleteAssetEvent error on call', id);
        }
    }
    async updateAssetEvent(id, assetEvent) {
        try {
            const response = await this.httpClient.put(`/asset-events/${id}`, assetEvent);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'updateAssetEvent error on a call', id, assetEvent);
        }
    }
    async getAssets(filter) {
        try {
            const response = await this.httpClient.get('/assets', {
                params: filter,
            });
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getAssets error on a call', filter);
        }
    }
    async getAsset(id) {
        try {
            const response = await this.httpClient.get(`/assets/${id}`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getAsset error on a call', id);
        }
    }
    async createAsset(asset) {
        try {
            const response = await this.httpClient.post('/assets', asset);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'createAsset error on a call', asset);
        }
    }
    async updateAsset(id, asset) {
        try {
            const response = await this.httpClient.put(`/Assets/${id}`, asset);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'updateAsset error on a call', id, asset);
        }
    }
    async getLockPin(request) {
        try {
            const response = await this.httpClient.post('assets/lockpin', request);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getLockPin error on call', request);
        }
    }
    // Asset photos:
    async getAssetPhotos(filter) {
        try {
            const response = await this.httpClient.get('/assetPhoto', {
                params: filter,
            });
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getAssets error on a call', filter);
        }
    }
    async getAssetPhoto(id) {
        try {
            const response = await this.httpClient.get(`/assetPhoto/${id}`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getAssetPhoto error on a call', id);
        }
    }
    async createAssetPhoto(assetPhoto) {
        try {
            const response = await this.httpClient.post('/assetPhoto', assetPhoto);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'createAssetPhoto error on a call', assetPhoto);
        }
    }
    async updateAssetPhoto(id, assetPhoto) {
        try {
            const response = await this.httpClient.put(`/assetPhoto/${id}`, assetPhoto);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'updateAssetPhoto error on a call', id, assetPhoto);
        }
    }
    async deleteAssetPhoto(id) {
        try {
            const response = await this.httpClient.delete(`/assetPhoto/${id}`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'deleteAssetPhoto error on a call', id);
        }
    }
    async getEventLogs(filter) {
        try {
            const response = await this.httpClient.get('/eventlogs', {
                params: filter,
            });
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getEventLogs error on a call', filter);
        }
    }
    async getEventLog(id) {
        try {
            const response = await this.httpClient.get(`/eventlogs/${id}`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getEventLog error on a call', id);
        }
    }
    async createEventLog(eventlog) {
        try {
            const response = await this.httpClient.post('/eventlogs', eventlog);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'createEventLog error on a call', eventlog);
        }
    }
    async assetArrive(assetId, assetArriveRequest) {
        try {
            const response = await this.httpClient.post(`/assets/${assetId}/arrive`, assetArriveRequest);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'assetArrive error on a call', assetArriveRequest);
        }
    }
    async assetDepart(assetId, assetDepartRequest) {
        try {
            const response = await this.httpClient.post(`/assets/${assetId}/depart`, assetDepartRequest);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'assetDepart error on a call', assetDepartRequest);
        }
    }
    async getAvailabilityInfo(request) {
        try {
            const response = await this.httpClient.get('/assets/availability', {
                params: request,
            });
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getAvailabilityInfo error on a call', request);
        }
    }
    async setGpsCoordinates(setGpsCoordinatesRequest) {
        try {
            const response = await this.httpClient.post('/assets/setGpsCoordinates', setGpsCoordinatesRequest);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'setGpsCoordinates error on a call', setGpsCoordinatesRequest);
        }
    }
    async setLockPin(assetId, request) {
        try {
            const response = await this.httpClient.post(`/assets/${assetId}/setLockPin`, request);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'setLockPin error on a call', request);
        }
    }
    async setOrderAssetState(request) {
        try {
            const response = await this.httpClient.post('/maintenances/asset/state', request);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'setOrderAssetState error on a call', request);
        }
    }
    async generateVisualTag(request) {
        try {
            const response = await this.httpClient.post('/assets/visualTag', request);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'generateVisualTag error on a call', request);
        }
    }
    async generateVisualTagCountryCode(request) {
        try {
            const response = await this.httpClient.post('/assets/visualTagCountryCode', request);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'generateVisualTagCountryCode error on a call', request);
        }
    }
    // Products
    async getProductIds(filter) {
        try {
            const response = await this.httpClient.get('/assets/products', {
                params: filter,
            });
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getProductIds error on a call', filter);
        }
    }
    // Consumable Assets
    async getConsumableAssets(filter, sortingData) {
        try {
            const params = { ...filter, ...sortingData };
            const response = await this.httpClient.get('/consumable-assets', {
                params,
            });
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getConsumableAssets error on a call', filter, sortingData);
        }
    }
    async getConsumableAsset(id) {
        try {
            const response = await this.httpClient.get(`/consumable-assets/${id}`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getConsumableAsset error on a call', id);
        }
    }
    async createConsumableAsset(request) {
        try {
            const response = await this.httpClient.post('/consumable-assets', request);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'createConsumableAsset error on a call', request);
        }
    }
    async updateConsumableAsset(id, request) {
        try {
            const response = await this.httpClient.put(`/consumable-assets/${id}`, request);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'updateConsumableAsset error on a call', id, request);
        }
    }
    async changeConsumableAssetStock(request) {
        try {
            const response = await this.httpClient.put('/consumable-assets/stock', request);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'changeConsumableAssetStock error on a call', request);
        }
    }
    async restockConsumableAsset(request) {
        try {
            const response = await this.httpClient.put('/consumable-assets/re-stock', request);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'restockConsumableAsset error on a call', request);
        }
    }
    // Consumable Asset Change Logs
    async getConsumableAssetChangeLog(id) {
        try {
            const response = await this.httpClient.get(`/consumable-asset-change-logs/${id}`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getConsumableAssetChangeLog error on a call', id);
        }
    }
    async getConsumableAssetChangeLogs(filter, sortingData) {
        try {
            const params = { ...filter, ...sortingData };
            const response = await this.httpClient.get('/consumable-asset-change-logs', {
                params,
            });
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getConsumableAssetChangeLogs error on a call', filter, sortingData);
        }
    }
    // Asset Lock Pin Code Logs
    async getAssetLockPinCodeLog(id) {
        try {
            const response = await this.httpClient.get(`/asset-lock-pin-code-logs/${id}`);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getAssetLockPinCodeLog error on a call', id);
        }
    }
    async getAssetLockPinCodeLogs(filter, sortingData) {
        try {
            const params = { ...filter, ...sortingData };
            const response = await this.httpClient.get('/asset-lock-pin-code-logs', {
                params,
            });
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'getAssetLockPinCodeLogs error on a call', filter, sortingData);
        }
    }
    async createAssetLockPinCodeLog(request) {
        try {
            const response = await this.httpClient.post('/asset-lock-pin-code-logs', request);
            return response.data;
        }
        catch (err) {
            return this.processError(err, 'createAssetLockPinCodeLog error on a call', request);
        }
    }
}
exports.AssetClient = AssetClient;
